// Logo PETROCONTROL - Imagen oficial

export default function PetrocontrolLogo({ className = "h-10", style = {} }) {
  return (
    <img 
      src="/logo-petrocontrol.png" 
      alt="PETROCONTROL" 
      className={className}
      style={{ objectFit: 'contain', ...style }}
    />
  );
}

// Versión solo icono (para favicon o usos pequeños)
export function PetrocontrolIcon({ className = "h-8 w-8", color = "#1a5c4a" }) {
  return (
    <svg 
      className={className} 
      viewBox="0 0 36 36" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Forma de gota */}
      <path 
        d="M18 0C18 0 4 16 4 24C4 30.627 10.373 36 18 36C25.627 36 32 30.627 32 24C32 16 18 0 18 0Z" 
        fill={color}
      />
      {/* Checkmark blanco */}
      <path 
        d="M11 22L16 27L26 16" 
        stroke="white" 
        strokeWidth="3.5" 
        strokeLinecap="round" 
        strokeLinejoin="round"
        fill="none"
      />
    </svg>
  );
}
